// STATES
export const OFFLINE = 'offline';
export const ONLINE = 'online';

// SERVICES
export const NEPHRO_MASTER = 'NephroMaster';
export const NEPHRO_AUTH = 'NephroAuth';
export const NEPHRO_INTEGRATOR = 'NephroIntegrator';
export const NEPHRO_CALENDAR = 'NephroCalendar';
export const NEPHRO_MEDIA = 'NephroMedia';
export const NEPHRO_COMMON = 'NephroCommon';
